import type { DeviceStatusData } from "@/redux/device-event-last.reducer"
import React from "react"

import { getDeviceStatusDataByDeviceIdFromState } from "@/redux/device-event-last.reducer"
import { useRootSelector } from "@/redux/useRootSelector"

import type { DeviceProfileRouteParams } from "@/components/navigate"
import type { AcceptsChildren } from "@/theme"

import * as Models from "@/redux/models"

interface ProviderProps {
  value: DeviceStatusData
}

export function useDeviceProfile({
  codaDeviceAlias,
}: DeviceProfileRouteParams) {
  const deviceId = useRootSelector(
    (state) =>
      Models.deviceConfiguration
        .selectAll(state)
        .find(
          (configuration) => configuration.codaDeviceAlias === codaDeviceAlias,
        )?.deviceId,
  )

  return useRootSelector((state) => {
    if (typeof deviceId === "string") {
      return getDeviceStatusDataByDeviceIdFromState(state, deviceId)
    }
    return undefined
  })
}

// TODO: We need a better 'not found' strategy here
type ContextValue = DeviceStatusData

const Context = React.createContext<ContextValue | undefined>(undefined)

export function DeviceProfileContextProvider({
  children,
  value,
}: AcceptsChildren & ProviderProps): React.JSX.Element | null {
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export function useDeviceProfileContext(): ContextValue {
  const ctx = React.useContext(Context)
  if (typeof ctx === "undefined") {
    throw new TypeError(
      `Context must be used inside of DeviceProfileContextProvider`,
    )
  }
  return ctx
}
